import { render, staticRenderFns } from "./getOil.vue?vue&type=template&id=de2df3ac&scoped=true"
import script from "./getOil.vue?vue&type=script&lang=js"
export * from "./getOil.vue?vue&type=script&lang=js"
import style0 from "./getOil.vue?vue&type=style&index=0&id=de2df3ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2df3ac",
  null
  
)

export default component.exports